import {
  IDeprecatedTalk,
  IOptionsResponse,
  ITalk,
  ITalkQuestionnaire,
  ITalkSheet,
  ITalkSheetPayload,
  QuestionnaireType,
  QuestionType,
  SubmissionStatus,
  ISubmitSessionDatePayload
} from "src/common/types";
import { mapElement } from "src/modules/MyQuestionnaire/helpers";
import { ISubmitTalkSheetPayload } from "../types";

export const mapTalkSheet = (talkSheet: ITalkSheetPayload): ITalkSheet => {
  let {
    peerSummaryTemplateElements,
    supervisorTemplateElements,
    selfTemplateElements,
    finalRating,
    config,
    anonymousDirectSupervisorElements
  } = talkSheet;
  const { newTextActionPlan, previousTextActionPlan, previousItemizedActionPlan, newItemizedActionPlan } = talkSheet;
  peerSummaryTemplateElements = peerSummaryTemplateElements || [];
  anonymousDirectSupervisorElements = anonymousDirectSupervisorElements || [];
  supervisorTemplateElements = supervisorTemplateElements || [];
  selfTemplateElements = selfTemplateElements || [];

  const finalRatingQuestion = supervisorTemplateElements.find(element => {
    return (element.question && element.question.type === QuestionType.FinalRating) || false;
  });

  if (finalRatingQuestion) {
    supervisorTemplateElements = supervisorTemplateElements.filter(({ id: elementId }) => {
      return elementId !== finalRatingQuestion.id;
    });

    finalRating =
      finalRating === null && finalRatingQuestion.question && finalRatingQuestion.question.response
        ? Math.round((finalRatingQuestion.question.response as IOptionsResponse).value)
        : finalRating;
  }

  if (config && config.showFinalRatingToParticipant) {
    config = {
      showFinalRatingToParticipant: true
    };
  }

  return {
    config,
    finalRating,
    newTextActionPlan,
    previousTextActionPlan,
    previousItemizedActionPlan,
    newItemizedActionPlan,
    finalRatingElement: finalRatingQuestion || null,
    peerSummaryTemplateElements: peerSummaryTemplateElements.map(mapElement),
    anonymousDirectSupervisorElements: anonymousDirectSupervisorElements.map(mapElement),
    selfTemplateElements: selfTemplateElements.map(mapElement),
    supervisorTemplateElements: supervisorTemplateElements.map(mapElement)
  };
};

// Extract fields from talk that are used for scheduling a talk date
export const mapSessionDatePayload = ({ scheduledDate }: IDeprecatedTalk): ISubmitSessionDatePayload => ({
  scheduledDate
});

// Extract fields from talk sheet that are used for submission
export const mapTalkSheetPayload = ({
  config,
  finalRating,
  newItemizedActionPlan,
  newTextActionPlan,
  previousItemizedActionPlan,
  previousTextActionPlan
}: ITalkSheet): ISubmitTalkSheetPayload => {
  const sortedNewActionPlan = newItemizedActionPlan?.actionPlanItems?.sort((a, b) => a.itemOrder - b.itemOrder);
  const sortedPreviousActionPlan = previousItemizedActionPlan?.actionPlanItems?.sort(
    (a, b) => a.itemOrder - b.itemOrder
  );
  return {
    config,
    finalRating,
    newItemizedActionPlan: { actionPlanItems: sortedNewActionPlan },
    newTextActionPlan,
    previousItemizedActionPlan: { actionPlanItems: sortedPreviousActionPlan },
    previousTextActionPlan
  };
};
// Used mainly to stringify config object for submission. It can include other conversions as well
export const mapTalkSheetForSubmission = (data: any) => {
  const preparedData = {
    ...data,
    newActionPlan: {
      actionPlanItems: data.newActionPlan.actionPlanItems.map((item: any, index: number) => ({
        ...item,
        itemOrder: index
      }))
    }
  };
  return preparedData.config ? { ...preparedData, config: JSON.stringify(preparedData.config) } : { ...preparedData };
};
export const getOtherPartyPlaceholder = (
  currentParty: ITalkQuestionnaire,
  otherParty: ITalkQuestionnaire,
  talk: ITalk
) =>
  [QuestionnaireType.DirectSupervisor].includes(currentParty.questionnaireType)
    ? [SubmissionStatus.Submitted].includes(otherParty.submissionStatus)
      ? `feedback.page.talk-sheet.noResponse`
      : `feedback.page.talk-sheet.waitingForResponse`
    : ![SubmissionStatus.Submitted].includes(otherParty.submissionStatus)
    ? `feedback.page.talk-sheet.waitingForResponse`
    : talk.supervisorSignedDate
    ? `feedback.page.talk-sheet.noResponse`
    : `feedback.page.talk-sheet.waitingForTalk`;
